import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { environment } from '../../environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from '../app.component';
import { provideHttpClient } from '@angular/common/http';

bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(),
    // Other providers here
  ]
}).catch(err => console.error(err));

@Component({
  selector: 'app-input-id-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    
// TODO: `HttpClientModule` should not be imported into a component directly.
// Please refactor the code to add `provideHttpClient()` call to the provider list in the
// application bootstrap logic and remove the `HttpClientModule` import from this component.
//HttpClientModule  // Add HttpClientModule here
  ],
  templateUrl: './input-id-dialog.component.html',
  styleUrls: ['./input-id-dialog.component.css']
})
export class InputIdDialogComponent {
  form: FormGroup;
  private baseUrl = environment.baseUrl; // Update with your actual port
  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    public dialogRef: MatDialogRef<InputIdDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { label: string, apiUrl: string, currentId: string}
  ) {
    this.form = this.fb.group({
      guidInput: ['', [Validators.required, Validators.pattern(
        /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/
      )]]
    });
  }

  onSubmit(): void {
    const url = `${this.baseUrl}/${this.data.apiUrl}`;
    if (this.form.valid) {
      const assignedGuid = this.form.value.guidInput;
      const currentId = this.data.currentId;
      this.http.post(url, { id: currentId , toBeAssigned: assignedGuid}).subscribe(() => {
        this.dialogRef.close();
      });
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
